import { render, staticRenderFns } from "./portrait-search.vue?vue&type=template&id=36528322&scoped=true&"
import script from "./portrait-search.vue?vue&type=script&lang=ts&"
export * from "./portrait-search.vue?vue&type=script&lang=ts&"
import style0 from "./portrait-search.vue?vue&type=style&index=0&id=36528322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36528322",
  null
  
)

export default component.exports